// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-w"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 5L5 18C5 18.5523 5.44772 19 6 19H12M12 19L12 5M12 19H18C18.5523 19 19 18.5523 19 18V5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersWIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-w',
    ref,
    icon: element,
  },
));

LettersWIcon.displayName = 'LettersWIcon';

export default LettersWIcon;
